export default "__VITE_ASSET__430f51c1__"